var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{on:{"click":function($event){return _vm.gotoBem(_vm.bem)}}},[_c('strong',[_vm._v(_vm._s(_vm.bem.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }